// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.2
//   protoc               unknown
// source: Protos/V1/Models/MarketplaceModels.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import Long from "long";
import { Timestamp } from "../../../google/protobuf/timestamp";

export const protobufPackage = "daisi.protos.v1";

export enum MarketplaceItemType {
  MARKETPLACE_ITEM_TYPE_SKILL = 0,
  MARKETPLACE_ITEM_TYPE_BOT_TOOL = 1,
  MARKETPLACE_ITEM_TYPE_HOST_TOOL = 2,
  MARKETPLACE_ITEM_TYPE_PLUGIN = 3,
  UNRECOGNIZED = -1,
}

export function marketplaceItemTypeFromJSON(object: any): MarketplaceItemType {
  switch (object) {
    case 0:
    case "MARKETPLACE_ITEM_TYPE_SKILL":
      return MarketplaceItemType.MARKETPLACE_ITEM_TYPE_SKILL;
    case 1:
    case "MARKETPLACE_ITEM_TYPE_BOT_TOOL":
      return MarketplaceItemType.MARKETPLACE_ITEM_TYPE_BOT_TOOL;
    case 2:
    case "MARKETPLACE_ITEM_TYPE_HOST_TOOL":
      return MarketplaceItemType.MARKETPLACE_ITEM_TYPE_HOST_TOOL;
    case 3:
    case "MARKETPLACE_ITEM_TYPE_PLUGIN":
      return MarketplaceItemType.MARKETPLACE_ITEM_TYPE_PLUGIN;
    case -1:
    case "UNRECOGNIZED":
    default:
      return MarketplaceItemType.UNRECOGNIZED;
  }
}

export function marketplaceItemTypeToJSON(object: MarketplaceItemType): string {
  switch (object) {
    case MarketplaceItemType.MARKETPLACE_ITEM_TYPE_SKILL:
      return "MARKETPLACE_ITEM_TYPE_SKILL";
    case MarketplaceItemType.MARKETPLACE_ITEM_TYPE_BOT_TOOL:
      return "MARKETPLACE_ITEM_TYPE_BOT_TOOL";
    case MarketplaceItemType.MARKETPLACE_ITEM_TYPE_HOST_TOOL:
      return "MARKETPLACE_ITEM_TYPE_HOST_TOOL";
    case MarketplaceItemType.MARKETPLACE_ITEM_TYPE_PLUGIN:
      return "MARKETPLACE_ITEM_TYPE_PLUGIN";
    case MarketplaceItemType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum MarketplacePricingModel {
  MARKETPLACE_PRICING_FREE = 0,
  MARKETPLACE_PRICING_ONE_TIME = 1,
  MARKETPLACE_PRICING_SUBSCRIPTION = 2,
  UNRECOGNIZED = -1,
}

export function marketplacePricingModelFromJSON(object: any): MarketplacePricingModel {
  switch (object) {
    case 0:
    case "MARKETPLACE_PRICING_FREE":
      return MarketplacePricingModel.MARKETPLACE_PRICING_FREE;
    case 1:
    case "MARKETPLACE_PRICING_ONE_TIME":
      return MarketplacePricingModel.MARKETPLACE_PRICING_ONE_TIME;
    case 2:
    case "MARKETPLACE_PRICING_SUBSCRIPTION":
      return MarketplacePricingModel.MARKETPLACE_PRICING_SUBSCRIPTION;
    case -1:
    case "UNRECOGNIZED":
    default:
      return MarketplacePricingModel.UNRECOGNIZED;
  }
}

export function marketplacePricingModelToJSON(object: MarketplacePricingModel): string {
  switch (object) {
    case MarketplacePricingModel.MARKETPLACE_PRICING_FREE:
      return "MARKETPLACE_PRICING_FREE";
    case MarketplacePricingModel.MARKETPLACE_PRICING_ONE_TIME:
      return "MARKETPLACE_PRICING_ONE_TIME";
    case MarketplacePricingModel.MARKETPLACE_PRICING_SUBSCRIPTION:
      return "MARKETPLACE_PRICING_SUBSCRIPTION";
    case MarketplacePricingModel.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface MarketplaceItemInfo {
  Id: string;
  AccountId: string;
  ProviderId: string;
  Name: string;
  Description: string;
  ShortDescription: string;
  Author: string;
  Version: string;
  IconUrl: string;
  Tags: string[];
  Screenshots: string[];
  ItemType: MarketplaceItemType;
  SkillId: string;
  ToolClassName: string;
  BundledItemIds: string[];
  PackageBlobUrl: string;
  PricingModel: MarketplacePricingModel;
  CreditPrice: Long;
  SubscriptionCreditPrice: Long;
  SubscriptionPeriodDays: number;
  Status: string;
  Visibility: string;
  ReviewedBy: string;
  ReviewedAt?: Date | undefined;
  RejectionReason: string;
  DownloadCount: number;
  PurchaseCount: number;
  AverageRating: number;
  RatingCount: number;
  CreatedAt?: Date | undefined;
  UpdatedAt?: Date | undefined;
}

export interface MarketplacePurchaseInfo {
  Id: string;
  AccountId: string;
  MarketplaceItemId: string;
  MarketplaceItemName: string;
  ItemType: MarketplaceItemType;
  CreditsPaid: Long;
  TransactionId: string;
  IsSubscription: boolean;
  SubscriptionExpiresAt?: Date | undefined;
  IsActive: boolean;
  PurchasedAt?: Date | undefined;
}

export interface ProviderProfileInfo {
  Id: string;
  AccountId: string;
  DisplayName: string;
  Bio: string;
  AvatarUrl: string;
  WebsiteUrl: string;
  Status: string;
  RevenueSharePercent: number;
  TotalEarnings: Long;
  PendingPayout: Long;
  ItemCount: number;
  CreatedAt?: Date | undefined;
  UpdatedAt?: Date | undefined;
}

export interface BrowseMarketplaceRequest {
  Search: string;
  Tag: string;
  ItemType: MarketplaceItemType;
  FilterByType: boolean;
}

export interface BrowseMarketplaceResponse {
  Items: MarketplaceItemInfo[];
}

export interface GetMarketplaceItemRequest {
  Id: string;
}

export interface GetMarketplaceItemResponse {
  Item?: MarketplaceItemInfo | undefined;
}

export interface CreateMarketplaceItemRequest {
  Item?: MarketplaceItemInfo | undefined;
}

export interface CreateMarketplaceItemResponse {
  Item?: MarketplaceItemInfo | undefined;
}

export interface UpdateMarketplaceItemRequest {
  Item?: MarketplaceItemInfo | undefined;
}

export interface UpdateMarketplaceItemResponse {
  Item?: MarketplaceItemInfo | undefined;
}

export interface UploadPackageRequest {
  MarketplaceItemId: string;
  ChunkData: Uint8Array;
}

export interface UploadPackageResponse {
  PackageBlobUrl: string;
  Success: boolean;
  Error: string;
}

export interface PurchaseMarketplaceItemRequest {
  AccountId: string;
  MarketplaceItemId: string;
}

export interface PurchaseMarketplaceItemResponse {
  Success: boolean;
  Error: string;
  Purchase?: MarketplacePurchaseInfo | undefined;
}

export interface GetMyPurchasesRequest {
  AccountId: string;
}

export interface GetMyPurchasesResponse {
  Purchases: MarketplacePurchaseInfo[];
}

export interface CheckEntitlementRequest {
  AccountId: string;
  MarketplaceItemId: string;
}

export interface CheckEntitlementResponse {
  IsEntitled: boolean;
}

export interface GetProviderProfileRequest {
  AccountId: string;
}

export interface GetProviderProfileResponse {
  Profile?: ProviderProfileInfo | undefined;
}

export interface CreateProviderProfileRequest {
  Profile?: ProviderProfileInfo | undefined;
}

export interface CreateProviderProfileResponse {
  Profile?: ProviderProfileInfo | undefined;
}

export interface UpdateProviderProfileRequest {
  Profile?: ProviderProfileInfo | undefined;
}

export interface UpdateProviderProfileResponse {
  Profile?: ProviderProfileInfo | undefined;
}

export interface GetPendingReviewItemsRequest {
}

export interface GetPendingReviewItemsResponse {
  Items: MarketplaceItemInfo[];
}

export interface ReviewMarketplaceItemRequest {
  MarketplaceItemId: string;
  ReviewerEmail: string;
  Approved: boolean;
  RejectionReason: string;
}

export interface ReviewMarketplaceItemResponse {
  Item?: MarketplaceItemInfo | undefined;
}

export interface GetPendingProviderProfilesRequest {
}

export interface GetPendingProviderProfilesResponse {
  Profiles: ProviderProfileInfo[];
}

export interface ReviewProviderProfileRequest {
  AccountId: string;
  ReviewerEmail: string;
  Approved: boolean;
}

export interface ReviewProviderProfileResponse {
  Profile?: ProviderProfileInfo | undefined;
}

function createBaseMarketplaceItemInfo(): MarketplaceItemInfo {
  return {
    Id: "",
    AccountId: "",
    ProviderId: "",
    Name: "",
    Description: "",
    ShortDescription: "",
    Author: "",
    Version: "",
    IconUrl: "",
    Tags: [],
    Screenshots: [],
    ItemType: 0,
    SkillId: "",
    ToolClassName: "",
    BundledItemIds: [],
    PackageBlobUrl: "",
    PricingModel: 0,
    CreditPrice: Long.ZERO,
    SubscriptionCreditPrice: Long.ZERO,
    SubscriptionPeriodDays: 0,
    Status: "",
    Visibility: "",
    ReviewedBy: "",
    ReviewedAt: undefined,
    RejectionReason: "",
    DownloadCount: 0,
    PurchaseCount: 0,
    AverageRating: 0,
    RatingCount: 0,
    CreatedAt: undefined,
    UpdatedAt: undefined,
  };
}

export const MarketplaceItemInfo: MessageFns<MarketplaceItemInfo> = {
  encode(message: MarketplaceItemInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Id !== "") {
      writer.uint32(10).string(message.Id);
    }
    if (message.AccountId !== "") {
      writer.uint32(18).string(message.AccountId);
    }
    if (message.ProviderId !== "") {
      writer.uint32(26).string(message.ProviderId);
    }
    if (message.Name !== "") {
      writer.uint32(34).string(message.Name);
    }
    if (message.Description !== "") {
      writer.uint32(42).string(message.Description);
    }
    if (message.ShortDescription !== "") {
      writer.uint32(50).string(message.ShortDescription);
    }
    if (message.Author !== "") {
      writer.uint32(58).string(message.Author);
    }
    if (message.Version !== "") {
      writer.uint32(66).string(message.Version);
    }
    if (message.IconUrl !== "") {
      writer.uint32(74).string(message.IconUrl);
    }
    for (const v of message.Tags) {
      writer.uint32(82).string(v!);
    }
    for (const v of message.Screenshots) {
      writer.uint32(90).string(v!);
    }
    if (message.ItemType !== 0) {
      writer.uint32(96).int32(message.ItemType);
    }
    if (message.SkillId !== "") {
      writer.uint32(106).string(message.SkillId);
    }
    if (message.ToolClassName !== "") {
      writer.uint32(114).string(message.ToolClassName);
    }
    for (const v of message.BundledItemIds) {
      writer.uint32(122).string(v!);
    }
    if (message.PackageBlobUrl !== "") {
      writer.uint32(130).string(message.PackageBlobUrl);
    }
    if (message.PricingModel !== 0) {
      writer.uint32(136).int32(message.PricingModel);
    }
    if (!message.CreditPrice.equals(Long.ZERO)) {
      writer.uint32(144).int64(message.CreditPrice.toString());
    }
    if (!message.SubscriptionCreditPrice.equals(Long.ZERO)) {
      writer.uint32(152).int64(message.SubscriptionCreditPrice.toString());
    }
    if (message.SubscriptionPeriodDays !== 0) {
      writer.uint32(160).int32(message.SubscriptionPeriodDays);
    }
    if (message.Status !== "") {
      writer.uint32(170).string(message.Status);
    }
    if (message.Visibility !== "") {
      writer.uint32(178).string(message.Visibility);
    }
    if (message.ReviewedBy !== "") {
      writer.uint32(186).string(message.ReviewedBy);
    }
    if (message.ReviewedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.ReviewedAt), writer.uint32(194).fork()).join();
    }
    if (message.RejectionReason !== "") {
      writer.uint32(202).string(message.RejectionReason);
    }
    if (message.DownloadCount !== 0) {
      writer.uint32(208).int32(message.DownloadCount);
    }
    if (message.PurchaseCount !== 0) {
      writer.uint32(216).int32(message.PurchaseCount);
    }
    if (message.AverageRating !== 0) {
      writer.uint32(225).double(message.AverageRating);
    }
    if (message.RatingCount !== 0) {
      writer.uint32(232).int32(message.RatingCount);
    }
    if (message.CreatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.CreatedAt), writer.uint32(242).fork()).join();
    }
    if (message.UpdatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.UpdatedAt), writer.uint32(250).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MarketplaceItemInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMarketplaceItemInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.AccountId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.ProviderId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.Name = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.Description = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.ShortDescription = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.Author = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.Version = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.IconUrl = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.Tags.push(reader.string());
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.Screenshots.push(reader.string());
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.ItemType = reader.int32() as any;
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.SkillId = reader.string();
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.ToolClassName = reader.string();
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.BundledItemIds.push(reader.string());
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.PackageBlobUrl = reader.string();
          continue;
        }
        case 17: {
          if (tag !== 136) {
            break;
          }

          message.PricingModel = reader.int32() as any;
          continue;
        }
        case 18: {
          if (tag !== 144) {
            break;
          }

          message.CreditPrice = Long.fromString(reader.int64().toString());
          continue;
        }
        case 19: {
          if (tag !== 152) {
            break;
          }

          message.SubscriptionCreditPrice = Long.fromString(reader.int64().toString());
          continue;
        }
        case 20: {
          if (tag !== 160) {
            break;
          }

          message.SubscriptionPeriodDays = reader.int32();
          continue;
        }
        case 21: {
          if (tag !== 170) {
            break;
          }

          message.Status = reader.string();
          continue;
        }
        case 22: {
          if (tag !== 178) {
            break;
          }

          message.Visibility = reader.string();
          continue;
        }
        case 23: {
          if (tag !== 186) {
            break;
          }

          message.ReviewedBy = reader.string();
          continue;
        }
        case 24: {
          if (tag !== 194) {
            break;
          }

          message.ReviewedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 25: {
          if (tag !== 202) {
            break;
          }

          message.RejectionReason = reader.string();
          continue;
        }
        case 26: {
          if (tag !== 208) {
            break;
          }

          message.DownloadCount = reader.int32();
          continue;
        }
        case 27: {
          if (tag !== 216) {
            break;
          }

          message.PurchaseCount = reader.int32();
          continue;
        }
        case 28: {
          if (tag !== 225) {
            break;
          }

          message.AverageRating = reader.double();
          continue;
        }
        case 29: {
          if (tag !== 232) {
            break;
          }

          message.RatingCount = reader.int32();
          continue;
        }
        case 30: {
          if (tag !== 242) {
            break;
          }

          message.CreatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 31: {
          if (tag !== 250) {
            break;
          }

          message.UpdatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MarketplaceItemInfo {
    return {
      Id: isSet(object.Id) ? globalThis.String(object.Id) : "",
      AccountId: isSet(object.AccountId) ? globalThis.String(object.AccountId) : "",
      ProviderId: isSet(object.ProviderId) ? globalThis.String(object.ProviderId) : "",
      Name: isSet(object.Name) ? globalThis.String(object.Name) : "",
      Description: isSet(object.Description) ? globalThis.String(object.Description) : "",
      ShortDescription: isSet(object.ShortDescription) ? globalThis.String(object.ShortDescription) : "",
      Author: isSet(object.Author) ? globalThis.String(object.Author) : "",
      Version: isSet(object.Version) ? globalThis.String(object.Version) : "",
      IconUrl: isSet(object.IconUrl) ? globalThis.String(object.IconUrl) : "",
      Tags: globalThis.Array.isArray(object?.Tags) ? object.Tags.map((e: any) => globalThis.String(e)) : [],
      Screenshots: globalThis.Array.isArray(object?.Screenshots)
        ? object.Screenshots.map((e: any) => globalThis.String(e))
        : [],
      ItemType: isSet(object.ItemType) ? marketplaceItemTypeFromJSON(object.ItemType) : 0,
      SkillId: isSet(object.SkillId) ? globalThis.String(object.SkillId) : "",
      ToolClassName: isSet(object.ToolClassName) ? globalThis.String(object.ToolClassName) : "",
      BundledItemIds: globalThis.Array.isArray(object?.BundledItemIds)
        ? object.BundledItemIds.map((e: any) => globalThis.String(e))
        : [],
      PackageBlobUrl: isSet(object.PackageBlobUrl) ? globalThis.String(object.PackageBlobUrl) : "",
      PricingModel: isSet(object.PricingModel) ? marketplacePricingModelFromJSON(object.PricingModel) : 0,
      CreditPrice: isSet(object.CreditPrice) ? Long.fromValue(object.CreditPrice) : Long.ZERO,
      SubscriptionCreditPrice: isSet(object.SubscriptionCreditPrice)
        ? Long.fromValue(object.SubscriptionCreditPrice)
        : Long.ZERO,
      SubscriptionPeriodDays: isSet(object.SubscriptionPeriodDays)
        ? globalThis.Number(object.SubscriptionPeriodDays)
        : 0,
      Status: isSet(object.Status) ? globalThis.String(object.Status) : "",
      Visibility: isSet(object.Visibility) ? globalThis.String(object.Visibility) : "",
      ReviewedBy: isSet(object.ReviewedBy) ? globalThis.String(object.ReviewedBy) : "",
      ReviewedAt: isSet(object.ReviewedAt) ? fromJsonTimestamp(object.ReviewedAt) : undefined,
      RejectionReason: isSet(object.RejectionReason) ? globalThis.String(object.RejectionReason) : "",
      DownloadCount: isSet(object.DownloadCount) ? globalThis.Number(object.DownloadCount) : 0,
      PurchaseCount: isSet(object.PurchaseCount) ? globalThis.Number(object.PurchaseCount) : 0,
      AverageRating: isSet(object.AverageRating) ? globalThis.Number(object.AverageRating) : 0,
      RatingCount: isSet(object.RatingCount) ? globalThis.Number(object.RatingCount) : 0,
      CreatedAt: isSet(object.CreatedAt) ? fromJsonTimestamp(object.CreatedAt) : undefined,
      UpdatedAt: isSet(object.UpdatedAt) ? fromJsonTimestamp(object.UpdatedAt) : undefined,
    };
  },

  toJSON(message: MarketplaceItemInfo): unknown {
    const obj: any = {};
    if (message.Id !== "") {
      obj.Id = message.Id;
    }
    if (message.AccountId !== "") {
      obj.AccountId = message.AccountId;
    }
    if (message.ProviderId !== "") {
      obj.ProviderId = message.ProviderId;
    }
    if (message.Name !== "") {
      obj.Name = message.Name;
    }
    if (message.Description !== "") {
      obj.Description = message.Description;
    }
    if (message.ShortDescription !== "") {
      obj.ShortDescription = message.ShortDescription;
    }
    if (message.Author !== "") {
      obj.Author = message.Author;
    }
    if (message.Version !== "") {
      obj.Version = message.Version;
    }
    if (message.IconUrl !== "") {
      obj.IconUrl = message.IconUrl;
    }
    if (message.Tags?.length) {
      obj.Tags = message.Tags;
    }
    if (message.Screenshots?.length) {
      obj.Screenshots = message.Screenshots;
    }
    if (message.ItemType !== 0) {
      obj.ItemType = marketplaceItemTypeToJSON(message.ItemType);
    }
    if (message.SkillId !== "") {
      obj.SkillId = message.SkillId;
    }
    if (message.ToolClassName !== "") {
      obj.ToolClassName = message.ToolClassName;
    }
    if (message.BundledItemIds?.length) {
      obj.BundledItemIds = message.BundledItemIds;
    }
    if (message.PackageBlobUrl !== "") {
      obj.PackageBlobUrl = message.PackageBlobUrl;
    }
    if (message.PricingModel !== 0) {
      obj.PricingModel = marketplacePricingModelToJSON(message.PricingModel);
    }
    if (!message.CreditPrice.equals(Long.ZERO)) {
      obj.CreditPrice = (message.CreditPrice || Long.ZERO).toString();
    }
    if (!message.SubscriptionCreditPrice.equals(Long.ZERO)) {
      obj.SubscriptionCreditPrice = (message.SubscriptionCreditPrice || Long.ZERO).toString();
    }
    if (message.SubscriptionPeriodDays !== 0) {
      obj.SubscriptionPeriodDays = Math.round(message.SubscriptionPeriodDays);
    }
    if (message.Status !== "") {
      obj.Status = message.Status;
    }
    if (message.Visibility !== "") {
      obj.Visibility = message.Visibility;
    }
    if (message.ReviewedBy !== "") {
      obj.ReviewedBy = message.ReviewedBy;
    }
    if (message.ReviewedAt !== undefined) {
      obj.ReviewedAt = message.ReviewedAt.toISOString();
    }
    if (message.RejectionReason !== "") {
      obj.RejectionReason = message.RejectionReason;
    }
    if (message.DownloadCount !== 0) {
      obj.DownloadCount = Math.round(message.DownloadCount);
    }
    if (message.PurchaseCount !== 0) {
      obj.PurchaseCount = Math.round(message.PurchaseCount);
    }
    if (message.AverageRating !== 0) {
      obj.AverageRating = message.AverageRating;
    }
    if (message.RatingCount !== 0) {
      obj.RatingCount = Math.round(message.RatingCount);
    }
    if (message.CreatedAt !== undefined) {
      obj.CreatedAt = message.CreatedAt.toISOString();
    }
    if (message.UpdatedAt !== undefined) {
      obj.UpdatedAt = message.UpdatedAt.toISOString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MarketplaceItemInfo>, I>>(base?: I): MarketplaceItemInfo {
    return MarketplaceItemInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MarketplaceItemInfo>, I>>(object: I): MarketplaceItemInfo {
    const message = createBaseMarketplaceItemInfo();
    message.Id = object.Id ?? "";
    message.AccountId = object.AccountId ?? "";
    message.ProviderId = object.ProviderId ?? "";
    message.Name = object.Name ?? "";
    message.Description = object.Description ?? "";
    message.ShortDescription = object.ShortDescription ?? "";
    message.Author = object.Author ?? "";
    message.Version = object.Version ?? "";
    message.IconUrl = object.IconUrl ?? "";
    message.Tags = object.Tags?.map((e) => e) || [];
    message.Screenshots = object.Screenshots?.map((e) => e) || [];
    message.ItemType = object.ItemType ?? 0;
    message.SkillId = object.SkillId ?? "";
    message.ToolClassName = object.ToolClassName ?? "";
    message.BundledItemIds = object.BundledItemIds?.map((e) => e) || [];
    message.PackageBlobUrl = object.PackageBlobUrl ?? "";
    message.PricingModel = object.PricingModel ?? 0;
    message.CreditPrice = (object.CreditPrice !== undefined && object.CreditPrice !== null)
      ? Long.fromValue(object.CreditPrice)
      : Long.ZERO;
    message.SubscriptionCreditPrice =
      (object.SubscriptionCreditPrice !== undefined && object.SubscriptionCreditPrice !== null)
        ? Long.fromValue(object.SubscriptionCreditPrice)
        : Long.ZERO;
    message.SubscriptionPeriodDays = object.SubscriptionPeriodDays ?? 0;
    message.Status = object.Status ?? "";
    message.Visibility = object.Visibility ?? "";
    message.ReviewedBy = object.ReviewedBy ?? "";
    message.ReviewedAt = object.ReviewedAt ?? undefined;
    message.RejectionReason = object.RejectionReason ?? "";
    message.DownloadCount = object.DownloadCount ?? 0;
    message.PurchaseCount = object.PurchaseCount ?? 0;
    message.AverageRating = object.AverageRating ?? 0;
    message.RatingCount = object.RatingCount ?? 0;
    message.CreatedAt = object.CreatedAt ?? undefined;
    message.UpdatedAt = object.UpdatedAt ?? undefined;
    return message;
  },
};

function createBaseMarketplacePurchaseInfo(): MarketplacePurchaseInfo {
  return {
    Id: "",
    AccountId: "",
    MarketplaceItemId: "",
    MarketplaceItemName: "",
    ItemType: 0,
    CreditsPaid: Long.ZERO,
    TransactionId: "",
    IsSubscription: false,
    SubscriptionExpiresAt: undefined,
    IsActive: false,
    PurchasedAt: undefined,
  };
}

export const MarketplacePurchaseInfo: MessageFns<MarketplacePurchaseInfo> = {
  encode(message: MarketplacePurchaseInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Id !== "") {
      writer.uint32(10).string(message.Id);
    }
    if (message.AccountId !== "") {
      writer.uint32(18).string(message.AccountId);
    }
    if (message.MarketplaceItemId !== "") {
      writer.uint32(26).string(message.MarketplaceItemId);
    }
    if (message.MarketplaceItemName !== "") {
      writer.uint32(34).string(message.MarketplaceItemName);
    }
    if (message.ItemType !== 0) {
      writer.uint32(40).int32(message.ItemType);
    }
    if (!message.CreditsPaid.equals(Long.ZERO)) {
      writer.uint32(48).int64(message.CreditsPaid.toString());
    }
    if (message.TransactionId !== "") {
      writer.uint32(58).string(message.TransactionId);
    }
    if (message.IsSubscription !== false) {
      writer.uint32(64).bool(message.IsSubscription);
    }
    if (message.SubscriptionExpiresAt !== undefined) {
      Timestamp.encode(toTimestamp(message.SubscriptionExpiresAt), writer.uint32(74).fork()).join();
    }
    if (message.IsActive !== false) {
      writer.uint32(80).bool(message.IsActive);
    }
    if (message.PurchasedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.PurchasedAt), writer.uint32(90).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MarketplacePurchaseInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMarketplacePurchaseInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.AccountId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.MarketplaceItemId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.MarketplaceItemName = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.ItemType = reader.int32() as any;
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.CreditsPaid = Long.fromString(reader.int64().toString());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.TransactionId = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.IsSubscription = reader.bool();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.SubscriptionExpiresAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.IsActive = reader.bool();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.PurchasedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MarketplacePurchaseInfo {
    return {
      Id: isSet(object.Id) ? globalThis.String(object.Id) : "",
      AccountId: isSet(object.AccountId) ? globalThis.String(object.AccountId) : "",
      MarketplaceItemId: isSet(object.MarketplaceItemId) ? globalThis.String(object.MarketplaceItemId) : "",
      MarketplaceItemName: isSet(object.MarketplaceItemName) ? globalThis.String(object.MarketplaceItemName) : "",
      ItemType: isSet(object.ItemType) ? marketplaceItemTypeFromJSON(object.ItemType) : 0,
      CreditsPaid: isSet(object.CreditsPaid) ? Long.fromValue(object.CreditsPaid) : Long.ZERO,
      TransactionId: isSet(object.TransactionId) ? globalThis.String(object.TransactionId) : "",
      IsSubscription: isSet(object.IsSubscription) ? globalThis.Boolean(object.IsSubscription) : false,
      SubscriptionExpiresAt: isSet(object.SubscriptionExpiresAt)
        ? fromJsonTimestamp(object.SubscriptionExpiresAt)
        : undefined,
      IsActive: isSet(object.IsActive) ? globalThis.Boolean(object.IsActive) : false,
      PurchasedAt: isSet(object.PurchasedAt) ? fromJsonTimestamp(object.PurchasedAt) : undefined,
    };
  },

  toJSON(message: MarketplacePurchaseInfo): unknown {
    const obj: any = {};
    if (message.Id !== "") {
      obj.Id = message.Id;
    }
    if (message.AccountId !== "") {
      obj.AccountId = message.AccountId;
    }
    if (message.MarketplaceItemId !== "") {
      obj.MarketplaceItemId = message.MarketplaceItemId;
    }
    if (message.MarketplaceItemName !== "") {
      obj.MarketplaceItemName = message.MarketplaceItemName;
    }
    if (message.ItemType !== 0) {
      obj.ItemType = marketplaceItemTypeToJSON(message.ItemType);
    }
    if (!message.CreditsPaid.equals(Long.ZERO)) {
      obj.CreditsPaid = (message.CreditsPaid || Long.ZERO).toString();
    }
    if (message.TransactionId !== "") {
      obj.TransactionId = message.TransactionId;
    }
    if (message.IsSubscription !== false) {
      obj.IsSubscription = message.IsSubscription;
    }
    if (message.SubscriptionExpiresAt !== undefined) {
      obj.SubscriptionExpiresAt = message.SubscriptionExpiresAt.toISOString();
    }
    if (message.IsActive !== false) {
      obj.IsActive = message.IsActive;
    }
    if (message.PurchasedAt !== undefined) {
      obj.PurchasedAt = message.PurchasedAt.toISOString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MarketplacePurchaseInfo>, I>>(base?: I): MarketplacePurchaseInfo {
    return MarketplacePurchaseInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MarketplacePurchaseInfo>, I>>(object: I): MarketplacePurchaseInfo {
    const message = createBaseMarketplacePurchaseInfo();
    message.Id = object.Id ?? "";
    message.AccountId = object.AccountId ?? "";
    message.MarketplaceItemId = object.MarketplaceItemId ?? "";
    message.MarketplaceItemName = object.MarketplaceItemName ?? "";
    message.ItemType = object.ItemType ?? 0;
    message.CreditsPaid = (object.CreditsPaid !== undefined && object.CreditsPaid !== null)
      ? Long.fromValue(object.CreditsPaid)
      : Long.ZERO;
    message.TransactionId = object.TransactionId ?? "";
    message.IsSubscription = object.IsSubscription ?? false;
    message.SubscriptionExpiresAt = object.SubscriptionExpiresAt ?? undefined;
    message.IsActive = object.IsActive ?? false;
    message.PurchasedAt = object.PurchasedAt ?? undefined;
    return message;
  },
};

function createBaseProviderProfileInfo(): ProviderProfileInfo {
  return {
    Id: "",
    AccountId: "",
    DisplayName: "",
    Bio: "",
    AvatarUrl: "",
    WebsiteUrl: "",
    Status: "",
    RevenueSharePercent: 0,
    TotalEarnings: Long.ZERO,
    PendingPayout: Long.ZERO,
    ItemCount: 0,
    CreatedAt: undefined,
    UpdatedAt: undefined,
  };
}

export const ProviderProfileInfo: MessageFns<ProviderProfileInfo> = {
  encode(message: ProviderProfileInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Id !== "") {
      writer.uint32(10).string(message.Id);
    }
    if (message.AccountId !== "") {
      writer.uint32(18).string(message.AccountId);
    }
    if (message.DisplayName !== "") {
      writer.uint32(26).string(message.DisplayName);
    }
    if (message.Bio !== "") {
      writer.uint32(34).string(message.Bio);
    }
    if (message.AvatarUrl !== "") {
      writer.uint32(42).string(message.AvatarUrl);
    }
    if (message.WebsiteUrl !== "") {
      writer.uint32(50).string(message.WebsiteUrl);
    }
    if (message.Status !== "") {
      writer.uint32(58).string(message.Status);
    }
    if (message.RevenueSharePercent !== 0) {
      writer.uint32(65).double(message.RevenueSharePercent);
    }
    if (!message.TotalEarnings.equals(Long.ZERO)) {
      writer.uint32(72).int64(message.TotalEarnings.toString());
    }
    if (!message.PendingPayout.equals(Long.ZERO)) {
      writer.uint32(80).int64(message.PendingPayout.toString());
    }
    if (message.ItemCount !== 0) {
      writer.uint32(88).int32(message.ItemCount);
    }
    if (message.CreatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.CreatedAt), writer.uint32(98).fork()).join();
    }
    if (message.UpdatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.UpdatedAt), writer.uint32(106).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ProviderProfileInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProviderProfileInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.AccountId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.DisplayName = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.Bio = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.AvatarUrl = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.WebsiteUrl = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.Status = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 65) {
            break;
          }

          message.RevenueSharePercent = reader.double();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.TotalEarnings = Long.fromString(reader.int64().toString());
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.PendingPayout = Long.fromString(reader.int64().toString());
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.ItemCount = reader.int32();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.CreatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.UpdatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ProviderProfileInfo {
    return {
      Id: isSet(object.Id) ? globalThis.String(object.Id) : "",
      AccountId: isSet(object.AccountId) ? globalThis.String(object.AccountId) : "",
      DisplayName: isSet(object.DisplayName) ? globalThis.String(object.DisplayName) : "",
      Bio: isSet(object.Bio) ? globalThis.String(object.Bio) : "",
      AvatarUrl: isSet(object.AvatarUrl) ? globalThis.String(object.AvatarUrl) : "",
      WebsiteUrl: isSet(object.WebsiteUrl) ? globalThis.String(object.WebsiteUrl) : "",
      Status: isSet(object.Status) ? globalThis.String(object.Status) : "",
      RevenueSharePercent: isSet(object.RevenueSharePercent) ? globalThis.Number(object.RevenueSharePercent) : 0,
      TotalEarnings: isSet(object.TotalEarnings) ? Long.fromValue(object.TotalEarnings) : Long.ZERO,
      PendingPayout: isSet(object.PendingPayout) ? Long.fromValue(object.PendingPayout) : Long.ZERO,
      ItemCount: isSet(object.ItemCount) ? globalThis.Number(object.ItemCount) : 0,
      CreatedAt: isSet(object.CreatedAt) ? fromJsonTimestamp(object.CreatedAt) : undefined,
      UpdatedAt: isSet(object.UpdatedAt) ? fromJsonTimestamp(object.UpdatedAt) : undefined,
    };
  },

  toJSON(message: ProviderProfileInfo): unknown {
    const obj: any = {};
    if (message.Id !== "") {
      obj.Id = message.Id;
    }
    if (message.AccountId !== "") {
      obj.AccountId = message.AccountId;
    }
    if (message.DisplayName !== "") {
      obj.DisplayName = message.DisplayName;
    }
    if (message.Bio !== "") {
      obj.Bio = message.Bio;
    }
    if (message.AvatarUrl !== "") {
      obj.AvatarUrl = message.AvatarUrl;
    }
    if (message.WebsiteUrl !== "") {
      obj.WebsiteUrl = message.WebsiteUrl;
    }
    if (message.Status !== "") {
      obj.Status = message.Status;
    }
    if (message.RevenueSharePercent !== 0) {
      obj.RevenueSharePercent = message.RevenueSharePercent;
    }
    if (!message.TotalEarnings.equals(Long.ZERO)) {
      obj.TotalEarnings = (message.TotalEarnings || Long.ZERO).toString();
    }
    if (!message.PendingPayout.equals(Long.ZERO)) {
      obj.PendingPayout = (message.PendingPayout || Long.ZERO).toString();
    }
    if (message.ItemCount !== 0) {
      obj.ItemCount = Math.round(message.ItemCount);
    }
    if (message.CreatedAt !== undefined) {
      obj.CreatedAt = message.CreatedAt.toISOString();
    }
    if (message.UpdatedAt !== undefined) {
      obj.UpdatedAt = message.UpdatedAt.toISOString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ProviderProfileInfo>, I>>(base?: I): ProviderProfileInfo {
    return ProviderProfileInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ProviderProfileInfo>, I>>(object: I): ProviderProfileInfo {
    const message = createBaseProviderProfileInfo();
    message.Id = object.Id ?? "";
    message.AccountId = object.AccountId ?? "";
    message.DisplayName = object.DisplayName ?? "";
    message.Bio = object.Bio ?? "";
    message.AvatarUrl = object.AvatarUrl ?? "";
    message.WebsiteUrl = object.WebsiteUrl ?? "";
    message.Status = object.Status ?? "";
    message.RevenueSharePercent = object.RevenueSharePercent ?? 0;
    message.TotalEarnings = (object.TotalEarnings !== undefined && object.TotalEarnings !== null)
      ? Long.fromValue(object.TotalEarnings)
      : Long.ZERO;
    message.PendingPayout = (object.PendingPayout !== undefined && object.PendingPayout !== null)
      ? Long.fromValue(object.PendingPayout)
      : Long.ZERO;
    message.ItemCount = object.ItemCount ?? 0;
    message.CreatedAt = object.CreatedAt ?? undefined;
    message.UpdatedAt = object.UpdatedAt ?? undefined;
    return message;
  },
};

function createBaseBrowseMarketplaceRequest(): BrowseMarketplaceRequest {
  return { Search: "", Tag: "", ItemType: 0, FilterByType: false };
}

export const BrowseMarketplaceRequest: MessageFns<BrowseMarketplaceRequest> = {
  encode(message: BrowseMarketplaceRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Search !== "") {
      writer.uint32(10).string(message.Search);
    }
    if (message.Tag !== "") {
      writer.uint32(18).string(message.Tag);
    }
    if (message.ItemType !== 0) {
      writer.uint32(24).int32(message.ItemType);
    }
    if (message.FilterByType !== false) {
      writer.uint32(32).bool(message.FilterByType);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BrowseMarketplaceRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBrowseMarketplaceRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Search = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.Tag = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.ItemType = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.FilterByType = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BrowseMarketplaceRequest {
    return {
      Search: isSet(object.Search) ? globalThis.String(object.Search) : "",
      Tag: isSet(object.Tag) ? globalThis.String(object.Tag) : "",
      ItemType: isSet(object.ItemType) ? marketplaceItemTypeFromJSON(object.ItemType) : 0,
      FilterByType: isSet(object.FilterByType) ? globalThis.Boolean(object.FilterByType) : false,
    };
  },

  toJSON(message: BrowseMarketplaceRequest): unknown {
    const obj: any = {};
    if (message.Search !== "") {
      obj.Search = message.Search;
    }
    if (message.Tag !== "") {
      obj.Tag = message.Tag;
    }
    if (message.ItemType !== 0) {
      obj.ItemType = marketplaceItemTypeToJSON(message.ItemType);
    }
    if (message.FilterByType !== false) {
      obj.FilterByType = message.FilterByType;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BrowseMarketplaceRequest>, I>>(base?: I): BrowseMarketplaceRequest {
    return BrowseMarketplaceRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BrowseMarketplaceRequest>, I>>(object: I): BrowseMarketplaceRequest {
    const message = createBaseBrowseMarketplaceRequest();
    message.Search = object.Search ?? "";
    message.Tag = object.Tag ?? "";
    message.ItemType = object.ItemType ?? 0;
    message.FilterByType = object.FilterByType ?? false;
    return message;
  },
};

function createBaseBrowseMarketplaceResponse(): BrowseMarketplaceResponse {
  return { Items: [] };
}

export const BrowseMarketplaceResponse: MessageFns<BrowseMarketplaceResponse> = {
  encode(message: BrowseMarketplaceResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.Items) {
      MarketplaceItemInfo.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BrowseMarketplaceResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBrowseMarketplaceResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Items.push(MarketplaceItemInfo.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BrowseMarketplaceResponse {
    return {
      Items: globalThis.Array.isArray(object?.Items)
        ? object.Items.map((e: any) => MarketplaceItemInfo.fromJSON(e))
        : [],
    };
  },

  toJSON(message: BrowseMarketplaceResponse): unknown {
    const obj: any = {};
    if (message.Items?.length) {
      obj.Items = message.Items.map((e) => MarketplaceItemInfo.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BrowseMarketplaceResponse>, I>>(base?: I): BrowseMarketplaceResponse {
    return BrowseMarketplaceResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BrowseMarketplaceResponse>, I>>(object: I): BrowseMarketplaceResponse {
    const message = createBaseBrowseMarketplaceResponse();
    message.Items = object.Items?.map((e) => MarketplaceItemInfo.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetMarketplaceItemRequest(): GetMarketplaceItemRequest {
  return { Id: "" };
}

export const GetMarketplaceItemRequest: MessageFns<GetMarketplaceItemRequest> = {
  encode(message: GetMarketplaceItemRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Id !== "") {
      writer.uint32(10).string(message.Id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetMarketplaceItemRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetMarketplaceItemRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetMarketplaceItemRequest {
    return { Id: isSet(object.Id) ? globalThis.String(object.Id) : "" };
  },

  toJSON(message: GetMarketplaceItemRequest): unknown {
    const obj: any = {};
    if (message.Id !== "") {
      obj.Id = message.Id;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetMarketplaceItemRequest>, I>>(base?: I): GetMarketplaceItemRequest {
    return GetMarketplaceItemRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetMarketplaceItemRequest>, I>>(object: I): GetMarketplaceItemRequest {
    const message = createBaseGetMarketplaceItemRequest();
    message.Id = object.Id ?? "";
    return message;
  },
};

function createBaseGetMarketplaceItemResponse(): GetMarketplaceItemResponse {
  return { Item: undefined };
}

export const GetMarketplaceItemResponse: MessageFns<GetMarketplaceItemResponse> = {
  encode(message: GetMarketplaceItemResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Item !== undefined) {
      MarketplaceItemInfo.encode(message.Item, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetMarketplaceItemResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetMarketplaceItemResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Item = MarketplaceItemInfo.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetMarketplaceItemResponse {
    return { Item: isSet(object.Item) ? MarketplaceItemInfo.fromJSON(object.Item) : undefined };
  },

  toJSON(message: GetMarketplaceItemResponse): unknown {
    const obj: any = {};
    if (message.Item !== undefined) {
      obj.Item = MarketplaceItemInfo.toJSON(message.Item);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetMarketplaceItemResponse>, I>>(base?: I): GetMarketplaceItemResponse {
    return GetMarketplaceItemResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetMarketplaceItemResponse>, I>>(object: I): GetMarketplaceItemResponse {
    const message = createBaseGetMarketplaceItemResponse();
    message.Item = (object.Item !== undefined && object.Item !== null)
      ? MarketplaceItemInfo.fromPartial(object.Item)
      : undefined;
    return message;
  },
};

function createBaseCreateMarketplaceItemRequest(): CreateMarketplaceItemRequest {
  return { Item: undefined };
}

export const CreateMarketplaceItemRequest: MessageFns<CreateMarketplaceItemRequest> = {
  encode(message: CreateMarketplaceItemRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Item !== undefined) {
      MarketplaceItemInfo.encode(message.Item, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateMarketplaceItemRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateMarketplaceItemRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Item = MarketplaceItemInfo.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateMarketplaceItemRequest {
    return { Item: isSet(object.Item) ? MarketplaceItemInfo.fromJSON(object.Item) : undefined };
  },

  toJSON(message: CreateMarketplaceItemRequest): unknown {
    const obj: any = {};
    if (message.Item !== undefined) {
      obj.Item = MarketplaceItemInfo.toJSON(message.Item);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateMarketplaceItemRequest>, I>>(base?: I): CreateMarketplaceItemRequest {
    return CreateMarketplaceItemRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateMarketplaceItemRequest>, I>>(object: I): CreateMarketplaceItemRequest {
    const message = createBaseCreateMarketplaceItemRequest();
    message.Item = (object.Item !== undefined && object.Item !== null)
      ? MarketplaceItemInfo.fromPartial(object.Item)
      : undefined;
    return message;
  },
};

function createBaseCreateMarketplaceItemResponse(): CreateMarketplaceItemResponse {
  return { Item: undefined };
}

export const CreateMarketplaceItemResponse: MessageFns<CreateMarketplaceItemResponse> = {
  encode(message: CreateMarketplaceItemResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Item !== undefined) {
      MarketplaceItemInfo.encode(message.Item, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateMarketplaceItemResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateMarketplaceItemResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Item = MarketplaceItemInfo.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateMarketplaceItemResponse {
    return { Item: isSet(object.Item) ? MarketplaceItemInfo.fromJSON(object.Item) : undefined };
  },

  toJSON(message: CreateMarketplaceItemResponse): unknown {
    const obj: any = {};
    if (message.Item !== undefined) {
      obj.Item = MarketplaceItemInfo.toJSON(message.Item);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateMarketplaceItemResponse>, I>>(base?: I): CreateMarketplaceItemResponse {
    return CreateMarketplaceItemResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateMarketplaceItemResponse>, I>>(
    object: I,
  ): CreateMarketplaceItemResponse {
    const message = createBaseCreateMarketplaceItemResponse();
    message.Item = (object.Item !== undefined && object.Item !== null)
      ? MarketplaceItemInfo.fromPartial(object.Item)
      : undefined;
    return message;
  },
};

function createBaseUpdateMarketplaceItemRequest(): UpdateMarketplaceItemRequest {
  return { Item: undefined };
}

export const UpdateMarketplaceItemRequest: MessageFns<UpdateMarketplaceItemRequest> = {
  encode(message: UpdateMarketplaceItemRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Item !== undefined) {
      MarketplaceItemInfo.encode(message.Item, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateMarketplaceItemRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateMarketplaceItemRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Item = MarketplaceItemInfo.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateMarketplaceItemRequest {
    return { Item: isSet(object.Item) ? MarketplaceItemInfo.fromJSON(object.Item) : undefined };
  },

  toJSON(message: UpdateMarketplaceItemRequest): unknown {
    const obj: any = {};
    if (message.Item !== undefined) {
      obj.Item = MarketplaceItemInfo.toJSON(message.Item);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateMarketplaceItemRequest>, I>>(base?: I): UpdateMarketplaceItemRequest {
    return UpdateMarketplaceItemRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateMarketplaceItemRequest>, I>>(object: I): UpdateMarketplaceItemRequest {
    const message = createBaseUpdateMarketplaceItemRequest();
    message.Item = (object.Item !== undefined && object.Item !== null)
      ? MarketplaceItemInfo.fromPartial(object.Item)
      : undefined;
    return message;
  },
};

function createBaseUpdateMarketplaceItemResponse(): UpdateMarketplaceItemResponse {
  return { Item: undefined };
}

export const UpdateMarketplaceItemResponse: MessageFns<UpdateMarketplaceItemResponse> = {
  encode(message: UpdateMarketplaceItemResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Item !== undefined) {
      MarketplaceItemInfo.encode(message.Item, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateMarketplaceItemResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateMarketplaceItemResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Item = MarketplaceItemInfo.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateMarketplaceItemResponse {
    return { Item: isSet(object.Item) ? MarketplaceItemInfo.fromJSON(object.Item) : undefined };
  },

  toJSON(message: UpdateMarketplaceItemResponse): unknown {
    const obj: any = {};
    if (message.Item !== undefined) {
      obj.Item = MarketplaceItemInfo.toJSON(message.Item);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateMarketplaceItemResponse>, I>>(base?: I): UpdateMarketplaceItemResponse {
    return UpdateMarketplaceItemResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateMarketplaceItemResponse>, I>>(
    object: I,
  ): UpdateMarketplaceItemResponse {
    const message = createBaseUpdateMarketplaceItemResponse();
    message.Item = (object.Item !== undefined && object.Item !== null)
      ? MarketplaceItemInfo.fromPartial(object.Item)
      : undefined;
    return message;
  },
};

function createBaseUploadPackageRequest(): UploadPackageRequest {
  return { MarketplaceItemId: "", ChunkData: new Uint8Array(0) };
}

export const UploadPackageRequest: MessageFns<UploadPackageRequest> = {
  encode(message: UploadPackageRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.MarketplaceItemId !== "") {
      writer.uint32(10).string(message.MarketplaceItemId);
    }
    if (message.ChunkData.length !== 0) {
      writer.uint32(18).bytes(message.ChunkData);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UploadPackageRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUploadPackageRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.MarketplaceItemId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ChunkData = reader.bytes();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UploadPackageRequest {
    return {
      MarketplaceItemId: isSet(object.MarketplaceItemId) ? globalThis.String(object.MarketplaceItemId) : "",
      ChunkData: isSet(object.ChunkData) ? bytesFromBase64(object.ChunkData) : new Uint8Array(0),
    };
  },

  toJSON(message: UploadPackageRequest): unknown {
    const obj: any = {};
    if (message.MarketplaceItemId !== "") {
      obj.MarketplaceItemId = message.MarketplaceItemId;
    }
    if (message.ChunkData.length !== 0) {
      obj.ChunkData = base64FromBytes(message.ChunkData);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UploadPackageRequest>, I>>(base?: I): UploadPackageRequest {
    return UploadPackageRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UploadPackageRequest>, I>>(object: I): UploadPackageRequest {
    const message = createBaseUploadPackageRequest();
    message.MarketplaceItemId = object.MarketplaceItemId ?? "";
    message.ChunkData = object.ChunkData ?? new Uint8Array(0);
    return message;
  },
};

function createBaseUploadPackageResponse(): UploadPackageResponse {
  return { PackageBlobUrl: "", Success: false, Error: "" };
}

export const UploadPackageResponse: MessageFns<UploadPackageResponse> = {
  encode(message: UploadPackageResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.PackageBlobUrl !== "") {
      writer.uint32(10).string(message.PackageBlobUrl);
    }
    if (message.Success !== false) {
      writer.uint32(16).bool(message.Success);
    }
    if (message.Error !== "") {
      writer.uint32(26).string(message.Error);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UploadPackageResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUploadPackageResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.PackageBlobUrl = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.Success = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.Error = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UploadPackageResponse {
    return {
      PackageBlobUrl: isSet(object.PackageBlobUrl) ? globalThis.String(object.PackageBlobUrl) : "",
      Success: isSet(object.Success) ? globalThis.Boolean(object.Success) : false,
      Error: isSet(object.Error) ? globalThis.String(object.Error) : "",
    };
  },

  toJSON(message: UploadPackageResponse): unknown {
    const obj: any = {};
    if (message.PackageBlobUrl !== "") {
      obj.PackageBlobUrl = message.PackageBlobUrl;
    }
    if (message.Success !== false) {
      obj.Success = message.Success;
    }
    if (message.Error !== "") {
      obj.Error = message.Error;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UploadPackageResponse>, I>>(base?: I): UploadPackageResponse {
    return UploadPackageResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UploadPackageResponse>, I>>(object: I): UploadPackageResponse {
    const message = createBaseUploadPackageResponse();
    message.PackageBlobUrl = object.PackageBlobUrl ?? "";
    message.Success = object.Success ?? false;
    message.Error = object.Error ?? "";
    return message;
  },
};

function createBasePurchaseMarketplaceItemRequest(): PurchaseMarketplaceItemRequest {
  return { AccountId: "", MarketplaceItemId: "" };
}

export const PurchaseMarketplaceItemRequest: MessageFns<PurchaseMarketplaceItemRequest> = {
  encode(message: PurchaseMarketplaceItemRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.AccountId !== "") {
      writer.uint32(10).string(message.AccountId);
    }
    if (message.MarketplaceItemId !== "") {
      writer.uint32(18).string(message.MarketplaceItemId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PurchaseMarketplaceItemRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePurchaseMarketplaceItemRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.AccountId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.MarketplaceItemId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PurchaseMarketplaceItemRequest {
    return {
      AccountId: isSet(object.AccountId) ? globalThis.String(object.AccountId) : "",
      MarketplaceItemId: isSet(object.MarketplaceItemId) ? globalThis.String(object.MarketplaceItemId) : "",
    };
  },

  toJSON(message: PurchaseMarketplaceItemRequest): unknown {
    const obj: any = {};
    if (message.AccountId !== "") {
      obj.AccountId = message.AccountId;
    }
    if (message.MarketplaceItemId !== "") {
      obj.MarketplaceItemId = message.MarketplaceItemId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PurchaseMarketplaceItemRequest>, I>>(base?: I): PurchaseMarketplaceItemRequest {
    return PurchaseMarketplaceItemRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PurchaseMarketplaceItemRequest>, I>>(
    object: I,
  ): PurchaseMarketplaceItemRequest {
    const message = createBasePurchaseMarketplaceItemRequest();
    message.AccountId = object.AccountId ?? "";
    message.MarketplaceItemId = object.MarketplaceItemId ?? "";
    return message;
  },
};

function createBasePurchaseMarketplaceItemResponse(): PurchaseMarketplaceItemResponse {
  return { Success: false, Error: "", Purchase: undefined };
}

export const PurchaseMarketplaceItemResponse: MessageFns<PurchaseMarketplaceItemResponse> = {
  encode(message: PurchaseMarketplaceItemResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Success !== false) {
      writer.uint32(8).bool(message.Success);
    }
    if (message.Error !== "") {
      writer.uint32(18).string(message.Error);
    }
    if (message.Purchase !== undefined) {
      MarketplacePurchaseInfo.encode(message.Purchase, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PurchaseMarketplaceItemResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePurchaseMarketplaceItemResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.Success = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.Error = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.Purchase = MarketplacePurchaseInfo.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PurchaseMarketplaceItemResponse {
    return {
      Success: isSet(object.Success) ? globalThis.Boolean(object.Success) : false,
      Error: isSet(object.Error) ? globalThis.String(object.Error) : "",
      Purchase: isSet(object.Purchase) ? MarketplacePurchaseInfo.fromJSON(object.Purchase) : undefined,
    };
  },

  toJSON(message: PurchaseMarketplaceItemResponse): unknown {
    const obj: any = {};
    if (message.Success !== false) {
      obj.Success = message.Success;
    }
    if (message.Error !== "") {
      obj.Error = message.Error;
    }
    if (message.Purchase !== undefined) {
      obj.Purchase = MarketplacePurchaseInfo.toJSON(message.Purchase);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PurchaseMarketplaceItemResponse>, I>>(base?: I): PurchaseMarketplaceItemResponse {
    return PurchaseMarketplaceItemResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PurchaseMarketplaceItemResponse>, I>>(
    object: I,
  ): PurchaseMarketplaceItemResponse {
    const message = createBasePurchaseMarketplaceItemResponse();
    message.Success = object.Success ?? false;
    message.Error = object.Error ?? "";
    message.Purchase = (object.Purchase !== undefined && object.Purchase !== null)
      ? MarketplacePurchaseInfo.fromPartial(object.Purchase)
      : undefined;
    return message;
  },
};

function createBaseGetMyPurchasesRequest(): GetMyPurchasesRequest {
  return { AccountId: "" };
}

export const GetMyPurchasesRequest: MessageFns<GetMyPurchasesRequest> = {
  encode(message: GetMyPurchasesRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.AccountId !== "") {
      writer.uint32(10).string(message.AccountId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetMyPurchasesRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetMyPurchasesRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.AccountId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetMyPurchasesRequest {
    return { AccountId: isSet(object.AccountId) ? globalThis.String(object.AccountId) : "" };
  },

  toJSON(message: GetMyPurchasesRequest): unknown {
    const obj: any = {};
    if (message.AccountId !== "") {
      obj.AccountId = message.AccountId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetMyPurchasesRequest>, I>>(base?: I): GetMyPurchasesRequest {
    return GetMyPurchasesRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetMyPurchasesRequest>, I>>(object: I): GetMyPurchasesRequest {
    const message = createBaseGetMyPurchasesRequest();
    message.AccountId = object.AccountId ?? "";
    return message;
  },
};

function createBaseGetMyPurchasesResponse(): GetMyPurchasesResponse {
  return { Purchases: [] };
}

export const GetMyPurchasesResponse: MessageFns<GetMyPurchasesResponse> = {
  encode(message: GetMyPurchasesResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.Purchases) {
      MarketplacePurchaseInfo.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetMyPurchasesResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetMyPurchasesResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Purchases.push(MarketplacePurchaseInfo.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetMyPurchasesResponse {
    return {
      Purchases: globalThis.Array.isArray(object?.Purchases)
        ? object.Purchases.map((e: any) => MarketplacePurchaseInfo.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GetMyPurchasesResponse): unknown {
    const obj: any = {};
    if (message.Purchases?.length) {
      obj.Purchases = message.Purchases.map((e) => MarketplacePurchaseInfo.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetMyPurchasesResponse>, I>>(base?: I): GetMyPurchasesResponse {
    return GetMyPurchasesResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetMyPurchasesResponse>, I>>(object: I): GetMyPurchasesResponse {
    const message = createBaseGetMyPurchasesResponse();
    message.Purchases = object.Purchases?.map((e) => MarketplacePurchaseInfo.fromPartial(e)) || [];
    return message;
  },
};

function createBaseCheckEntitlementRequest(): CheckEntitlementRequest {
  return { AccountId: "", MarketplaceItemId: "" };
}

export const CheckEntitlementRequest: MessageFns<CheckEntitlementRequest> = {
  encode(message: CheckEntitlementRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.AccountId !== "") {
      writer.uint32(10).string(message.AccountId);
    }
    if (message.MarketplaceItemId !== "") {
      writer.uint32(18).string(message.MarketplaceItemId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CheckEntitlementRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCheckEntitlementRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.AccountId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.MarketplaceItemId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CheckEntitlementRequest {
    return {
      AccountId: isSet(object.AccountId) ? globalThis.String(object.AccountId) : "",
      MarketplaceItemId: isSet(object.MarketplaceItemId) ? globalThis.String(object.MarketplaceItemId) : "",
    };
  },

  toJSON(message: CheckEntitlementRequest): unknown {
    const obj: any = {};
    if (message.AccountId !== "") {
      obj.AccountId = message.AccountId;
    }
    if (message.MarketplaceItemId !== "") {
      obj.MarketplaceItemId = message.MarketplaceItemId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CheckEntitlementRequest>, I>>(base?: I): CheckEntitlementRequest {
    return CheckEntitlementRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CheckEntitlementRequest>, I>>(object: I): CheckEntitlementRequest {
    const message = createBaseCheckEntitlementRequest();
    message.AccountId = object.AccountId ?? "";
    message.MarketplaceItemId = object.MarketplaceItemId ?? "";
    return message;
  },
};

function createBaseCheckEntitlementResponse(): CheckEntitlementResponse {
  return { IsEntitled: false };
}

export const CheckEntitlementResponse: MessageFns<CheckEntitlementResponse> = {
  encode(message: CheckEntitlementResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.IsEntitled !== false) {
      writer.uint32(8).bool(message.IsEntitled);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CheckEntitlementResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCheckEntitlementResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.IsEntitled = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CheckEntitlementResponse {
    return { IsEntitled: isSet(object.IsEntitled) ? globalThis.Boolean(object.IsEntitled) : false };
  },

  toJSON(message: CheckEntitlementResponse): unknown {
    const obj: any = {};
    if (message.IsEntitled !== false) {
      obj.IsEntitled = message.IsEntitled;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CheckEntitlementResponse>, I>>(base?: I): CheckEntitlementResponse {
    return CheckEntitlementResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CheckEntitlementResponse>, I>>(object: I): CheckEntitlementResponse {
    const message = createBaseCheckEntitlementResponse();
    message.IsEntitled = object.IsEntitled ?? false;
    return message;
  },
};

function createBaseGetProviderProfileRequest(): GetProviderProfileRequest {
  return { AccountId: "" };
}

export const GetProviderProfileRequest: MessageFns<GetProviderProfileRequest> = {
  encode(message: GetProviderProfileRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.AccountId !== "") {
      writer.uint32(10).string(message.AccountId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetProviderProfileRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetProviderProfileRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.AccountId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetProviderProfileRequest {
    return { AccountId: isSet(object.AccountId) ? globalThis.String(object.AccountId) : "" };
  },

  toJSON(message: GetProviderProfileRequest): unknown {
    const obj: any = {};
    if (message.AccountId !== "") {
      obj.AccountId = message.AccountId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetProviderProfileRequest>, I>>(base?: I): GetProviderProfileRequest {
    return GetProviderProfileRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetProviderProfileRequest>, I>>(object: I): GetProviderProfileRequest {
    const message = createBaseGetProviderProfileRequest();
    message.AccountId = object.AccountId ?? "";
    return message;
  },
};

function createBaseGetProviderProfileResponse(): GetProviderProfileResponse {
  return { Profile: undefined };
}

export const GetProviderProfileResponse: MessageFns<GetProviderProfileResponse> = {
  encode(message: GetProviderProfileResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Profile !== undefined) {
      ProviderProfileInfo.encode(message.Profile, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetProviderProfileResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetProviderProfileResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Profile = ProviderProfileInfo.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetProviderProfileResponse {
    return { Profile: isSet(object.Profile) ? ProviderProfileInfo.fromJSON(object.Profile) : undefined };
  },

  toJSON(message: GetProviderProfileResponse): unknown {
    const obj: any = {};
    if (message.Profile !== undefined) {
      obj.Profile = ProviderProfileInfo.toJSON(message.Profile);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetProviderProfileResponse>, I>>(base?: I): GetProviderProfileResponse {
    return GetProviderProfileResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetProviderProfileResponse>, I>>(object: I): GetProviderProfileResponse {
    const message = createBaseGetProviderProfileResponse();
    message.Profile = (object.Profile !== undefined && object.Profile !== null)
      ? ProviderProfileInfo.fromPartial(object.Profile)
      : undefined;
    return message;
  },
};

function createBaseCreateProviderProfileRequest(): CreateProviderProfileRequest {
  return { Profile: undefined };
}

export const CreateProviderProfileRequest: MessageFns<CreateProviderProfileRequest> = {
  encode(message: CreateProviderProfileRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Profile !== undefined) {
      ProviderProfileInfo.encode(message.Profile, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateProviderProfileRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateProviderProfileRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Profile = ProviderProfileInfo.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateProviderProfileRequest {
    return { Profile: isSet(object.Profile) ? ProviderProfileInfo.fromJSON(object.Profile) : undefined };
  },

  toJSON(message: CreateProviderProfileRequest): unknown {
    const obj: any = {};
    if (message.Profile !== undefined) {
      obj.Profile = ProviderProfileInfo.toJSON(message.Profile);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateProviderProfileRequest>, I>>(base?: I): CreateProviderProfileRequest {
    return CreateProviderProfileRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateProviderProfileRequest>, I>>(object: I): CreateProviderProfileRequest {
    const message = createBaseCreateProviderProfileRequest();
    message.Profile = (object.Profile !== undefined && object.Profile !== null)
      ? ProviderProfileInfo.fromPartial(object.Profile)
      : undefined;
    return message;
  },
};

function createBaseCreateProviderProfileResponse(): CreateProviderProfileResponse {
  return { Profile: undefined };
}

export const CreateProviderProfileResponse: MessageFns<CreateProviderProfileResponse> = {
  encode(message: CreateProviderProfileResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Profile !== undefined) {
      ProviderProfileInfo.encode(message.Profile, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateProviderProfileResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateProviderProfileResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Profile = ProviderProfileInfo.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateProviderProfileResponse {
    return { Profile: isSet(object.Profile) ? ProviderProfileInfo.fromJSON(object.Profile) : undefined };
  },

  toJSON(message: CreateProviderProfileResponse): unknown {
    const obj: any = {};
    if (message.Profile !== undefined) {
      obj.Profile = ProviderProfileInfo.toJSON(message.Profile);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateProviderProfileResponse>, I>>(base?: I): CreateProviderProfileResponse {
    return CreateProviderProfileResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateProviderProfileResponse>, I>>(
    object: I,
  ): CreateProviderProfileResponse {
    const message = createBaseCreateProviderProfileResponse();
    message.Profile = (object.Profile !== undefined && object.Profile !== null)
      ? ProviderProfileInfo.fromPartial(object.Profile)
      : undefined;
    return message;
  },
};

function createBaseUpdateProviderProfileRequest(): UpdateProviderProfileRequest {
  return { Profile: undefined };
}

export const UpdateProviderProfileRequest: MessageFns<UpdateProviderProfileRequest> = {
  encode(message: UpdateProviderProfileRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Profile !== undefined) {
      ProviderProfileInfo.encode(message.Profile, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateProviderProfileRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateProviderProfileRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Profile = ProviderProfileInfo.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateProviderProfileRequest {
    return { Profile: isSet(object.Profile) ? ProviderProfileInfo.fromJSON(object.Profile) : undefined };
  },

  toJSON(message: UpdateProviderProfileRequest): unknown {
    const obj: any = {};
    if (message.Profile !== undefined) {
      obj.Profile = ProviderProfileInfo.toJSON(message.Profile);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateProviderProfileRequest>, I>>(base?: I): UpdateProviderProfileRequest {
    return UpdateProviderProfileRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateProviderProfileRequest>, I>>(object: I): UpdateProviderProfileRequest {
    const message = createBaseUpdateProviderProfileRequest();
    message.Profile = (object.Profile !== undefined && object.Profile !== null)
      ? ProviderProfileInfo.fromPartial(object.Profile)
      : undefined;
    return message;
  },
};

function createBaseUpdateProviderProfileResponse(): UpdateProviderProfileResponse {
  return { Profile: undefined };
}

export const UpdateProviderProfileResponse: MessageFns<UpdateProviderProfileResponse> = {
  encode(message: UpdateProviderProfileResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Profile !== undefined) {
      ProviderProfileInfo.encode(message.Profile, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateProviderProfileResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateProviderProfileResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Profile = ProviderProfileInfo.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateProviderProfileResponse {
    return { Profile: isSet(object.Profile) ? ProviderProfileInfo.fromJSON(object.Profile) : undefined };
  },

  toJSON(message: UpdateProviderProfileResponse): unknown {
    const obj: any = {};
    if (message.Profile !== undefined) {
      obj.Profile = ProviderProfileInfo.toJSON(message.Profile);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateProviderProfileResponse>, I>>(base?: I): UpdateProviderProfileResponse {
    return UpdateProviderProfileResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateProviderProfileResponse>, I>>(
    object: I,
  ): UpdateProviderProfileResponse {
    const message = createBaseUpdateProviderProfileResponse();
    message.Profile = (object.Profile !== undefined && object.Profile !== null)
      ? ProviderProfileInfo.fromPartial(object.Profile)
      : undefined;
    return message;
  },
};

function createBaseGetPendingReviewItemsRequest(): GetPendingReviewItemsRequest {
  return {};
}

export const GetPendingReviewItemsRequest: MessageFns<GetPendingReviewItemsRequest> = {
  encode(_: GetPendingReviewItemsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetPendingReviewItemsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetPendingReviewItemsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): GetPendingReviewItemsRequest {
    return {};
  },

  toJSON(_: GetPendingReviewItemsRequest): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<GetPendingReviewItemsRequest>, I>>(base?: I): GetPendingReviewItemsRequest {
    return GetPendingReviewItemsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetPendingReviewItemsRequest>, I>>(_: I): GetPendingReviewItemsRequest {
    const message = createBaseGetPendingReviewItemsRequest();
    return message;
  },
};

function createBaseGetPendingReviewItemsResponse(): GetPendingReviewItemsResponse {
  return { Items: [] };
}

export const GetPendingReviewItemsResponse: MessageFns<GetPendingReviewItemsResponse> = {
  encode(message: GetPendingReviewItemsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.Items) {
      MarketplaceItemInfo.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetPendingReviewItemsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetPendingReviewItemsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Items.push(MarketplaceItemInfo.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetPendingReviewItemsResponse {
    return {
      Items: globalThis.Array.isArray(object?.Items)
        ? object.Items.map((e: any) => MarketplaceItemInfo.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GetPendingReviewItemsResponse): unknown {
    const obj: any = {};
    if (message.Items?.length) {
      obj.Items = message.Items.map((e) => MarketplaceItemInfo.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetPendingReviewItemsResponse>, I>>(base?: I): GetPendingReviewItemsResponse {
    return GetPendingReviewItemsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetPendingReviewItemsResponse>, I>>(
    object: I,
  ): GetPendingReviewItemsResponse {
    const message = createBaseGetPendingReviewItemsResponse();
    message.Items = object.Items?.map((e) => MarketplaceItemInfo.fromPartial(e)) || [];
    return message;
  },
};

function createBaseReviewMarketplaceItemRequest(): ReviewMarketplaceItemRequest {
  return { MarketplaceItemId: "", ReviewerEmail: "", Approved: false, RejectionReason: "" };
}

export const ReviewMarketplaceItemRequest: MessageFns<ReviewMarketplaceItemRequest> = {
  encode(message: ReviewMarketplaceItemRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.MarketplaceItemId !== "") {
      writer.uint32(10).string(message.MarketplaceItemId);
    }
    if (message.ReviewerEmail !== "") {
      writer.uint32(18).string(message.ReviewerEmail);
    }
    if (message.Approved !== false) {
      writer.uint32(24).bool(message.Approved);
    }
    if (message.RejectionReason !== "") {
      writer.uint32(34).string(message.RejectionReason);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ReviewMarketplaceItemRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseReviewMarketplaceItemRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.MarketplaceItemId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ReviewerEmail = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.Approved = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.RejectionReason = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ReviewMarketplaceItemRequest {
    return {
      MarketplaceItemId: isSet(object.MarketplaceItemId) ? globalThis.String(object.MarketplaceItemId) : "",
      ReviewerEmail: isSet(object.ReviewerEmail) ? globalThis.String(object.ReviewerEmail) : "",
      Approved: isSet(object.Approved) ? globalThis.Boolean(object.Approved) : false,
      RejectionReason: isSet(object.RejectionReason) ? globalThis.String(object.RejectionReason) : "",
    };
  },

  toJSON(message: ReviewMarketplaceItemRequest): unknown {
    const obj: any = {};
    if (message.MarketplaceItemId !== "") {
      obj.MarketplaceItemId = message.MarketplaceItemId;
    }
    if (message.ReviewerEmail !== "") {
      obj.ReviewerEmail = message.ReviewerEmail;
    }
    if (message.Approved !== false) {
      obj.Approved = message.Approved;
    }
    if (message.RejectionReason !== "") {
      obj.RejectionReason = message.RejectionReason;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ReviewMarketplaceItemRequest>, I>>(base?: I): ReviewMarketplaceItemRequest {
    return ReviewMarketplaceItemRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ReviewMarketplaceItemRequest>, I>>(object: I): ReviewMarketplaceItemRequest {
    const message = createBaseReviewMarketplaceItemRequest();
    message.MarketplaceItemId = object.MarketplaceItemId ?? "";
    message.ReviewerEmail = object.ReviewerEmail ?? "";
    message.Approved = object.Approved ?? false;
    message.RejectionReason = object.RejectionReason ?? "";
    return message;
  },
};

function createBaseReviewMarketplaceItemResponse(): ReviewMarketplaceItemResponse {
  return { Item: undefined };
}

export const ReviewMarketplaceItemResponse: MessageFns<ReviewMarketplaceItemResponse> = {
  encode(message: ReviewMarketplaceItemResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Item !== undefined) {
      MarketplaceItemInfo.encode(message.Item, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ReviewMarketplaceItemResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseReviewMarketplaceItemResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Item = MarketplaceItemInfo.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ReviewMarketplaceItemResponse {
    return { Item: isSet(object.Item) ? MarketplaceItemInfo.fromJSON(object.Item) : undefined };
  },

  toJSON(message: ReviewMarketplaceItemResponse): unknown {
    const obj: any = {};
    if (message.Item !== undefined) {
      obj.Item = MarketplaceItemInfo.toJSON(message.Item);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ReviewMarketplaceItemResponse>, I>>(base?: I): ReviewMarketplaceItemResponse {
    return ReviewMarketplaceItemResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ReviewMarketplaceItemResponse>, I>>(
    object: I,
  ): ReviewMarketplaceItemResponse {
    const message = createBaseReviewMarketplaceItemResponse();
    message.Item = (object.Item !== undefined && object.Item !== null)
      ? MarketplaceItemInfo.fromPartial(object.Item)
      : undefined;
    return message;
  },
};

function createBaseGetPendingProviderProfilesRequest(): GetPendingProviderProfilesRequest {
  return {};
}

export const GetPendingProviderProfilesRequest: MessageFns<GetPendingProviderProfilesRequest> = {
  encode(_: GetPendingProviderProfilesRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetPendingProviderProfilesRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetPendingProviderProfilesRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): GetPendingProviderProfilesRequest {
    return {};
  },

  toJSON(_: GetPendingProviderProfilesRequest): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<GetPendingProviderProfilesRequest>, I>>(
    base?: I,
  ): GetPendingProviderProfilesRequest {
    return GetPendingProviderProfilesRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetPendingProviderProfilesRequest>, I>>(
    _: I,
  ): GetPendingProviderProfilesRequest {
    const message = createBaseGetPendingProviderProfilesRequest();
    return message;
  },
};

function createBaseGetPendingProviderProfilesResponse(): GetPendingProviderProfilesResponse {
  return { Profiles: [] };
}

export const GetPendingProviderProfilesResponse: MessageFns<GetPendingProviderProfilesResponse> = {
  encode(message: GetPendingProviderProfilesResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.Profiles) {
      ProviderProfileInfo.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetPendingProviderProfilesResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetPendingProviderProfilesResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Profiles.push(ProviderProfileInfo.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetPendingProviderProfilesResponse {
    return {
      Profiles: globalThis.Array.isArray(object?.Profiles)
        ? object.Profiles.map((e: any) => ProviderProfileInfo.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GetPendingProviderProfilesResponse): unknown {
    const obj: any = {};
    if (message.Profiles?.length) {
      obj.Profiles = message.Profiles.map((e) => ProviderProfileInfo.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetPendingProviderProfilesResponse>, I>>(
    base?: I,
  ): GetPendingProviderProfilesResponse {
    return GetPendingProviderProfilesResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetPendingProviderProfilesResponse>, I>>(
    object: I,
  ): GetPendingProviderProfilesResponse {
    const message = createBaseGetPendingProviderProfilesResponse();
    message.Profiles = object.Profiles?.map((e) => ProviderProfileInfo.fromPartial(e)) || [];
    return message;
  },
};

function createBaseReviewProviderProfileRequest(): ReviewProviderProfileRequest {
  return { AccountId: "", ReviewerEmail: "", Approved: false };
}

export const ReviewProviderProfileRequest: MessageFns<ReviewProviderProfileRequest> = {
  encode(message: ReviewProviderProfileRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.AccountId !== "") {
      writer.uint32(10).string(message.AccountId);
    }
    if (message.ReviewerEmail !== "") {
      writer.uint32(18).string(message.ReviewerEmail);
    }
    if (message.Approved !== false) {
      writer.uint32(24).bool(message.Approved);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ReviewProviderProfileRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseReviewProviderProfileRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.AccountId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ReviewerEmail = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.Approved = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ReviewProviderProfileRequest {
    return {
      AccountId: isSet(object.AccountId) ? globalThis.String(object.AccountId) : "",
      ReviewerEmail: isSet(object.ReviewerEmail) ? globalThis.String(object.ReviewerEmail) : "",
      Approved: isSet(object.Approved) ? globalThis.Boolean(object.Approved) : false,
    };
  },

  toJSON(message: ReviewProviderProfileRequest): unknown {
    const obj: any = {};
    if (message.AccountId !== "") {
      obj.AccountId = message.AccountId;
    }
    if (message.ReviewerEmail !== "") {
      obj.ReviewerEmail = message.ReviewerEmail;
    }
    if (message.Approved !== false) {
      obj.Approved = message.Approved;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ReviewProviderProfileRequest>, I>>(base?: I): ReviewProviderProfileRequest {
    return ReviewProviderProfileRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ReviewProviderProfileRequest>, I>>(object: I): ReviewProviderProfileRequest {
    const message = createBaseReviewProviderProfileRequest();
    message.AccountId = object.AccountId ?? "";
    message.ReviewerEmail = object.ReviewerEmail ?? "";
    message.Approved = object.Approved ?? false;
    return message;
  },
};

function createBaseReviewProviderProfileResponse(): ReviewProviderProfileResponse {
  return { Profile: undefined };
}

export const ReviewProviderProfileResponse: MessageFns<ReviewProviderProfileResponse> = {
  encode(message: ReviewProviderProfileResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Profile !== undefined) {
      ProviderProfileInfo.encode(message.Profile, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ReviewProviderProfileResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseReviewProviderProfileResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Profile = ProviderProfileInfo.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ReviewProviderProfileResponse {
    return { Profile: isSet(object.Profile) ? ProviderProfileInfo.fromJSON(object.Profile) : undefined };
  },

  toJSON(message: ReviewProviderProfileResponse): unknown {
    const obj: any = {};
    if (message.Profile !== undefined) {
      obj.Profile = ProviderProfileInfo.toJSON(message.Profile);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ReviewProviderProfileResponse>, I>>(base?: I): ReviewProviderProfileResponse {
    return ReviewProviderProfileResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ReviewProviderProfileResponse>, I>>(
    object: I,
  ): ReviewProviderProfileResponse {
    const message = createBaseReviewProviderProfileResponse();
    message.Profile = (object.Profile !== undefined && object.Profile !== null)
      ? ProviderProfileInfo.fromPartial(object.Profile)
      : undefined;
    return message;
  },
};

function bytesFromBase64(b64: string): Uint8Array {
  if ((globalThis as any).Buffer) {
    return Uint8Array.from(globalThis.Buffer.from(b64, "base64"));
  } else {
    const bin = globalThis.atob(b64);
    const arr = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; ++i) {
      arr[i] = bin.charCodeAt(i);
    }
    return arr;
  }
}

function base64FromBytes(arr: Uint8Array): string {
  if ((globalThis as any).Buffer) {
    return globalThis.Buffer.from(arr).toString("base64");
  } else {
    const bin: string[] = [];
    arr.forEach((byte) => {
      bin.push(globalThis.String.fromCharCode(byte));
    });
    return globalThis.btoa(bin.join(""));
  }
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Long ? string | number | Long : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function toTimestamp(date: Date): Timestamp {
  const seconds = numberToLong(Math.trunc(date.getTime() / 1_000));
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds.toNumber() || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function numberToLong(number: number) {
  return Long.fromNumber(number);
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
